import { createFileRoute } from '@tanstack/react-router';
import { CompetenceMatrixPage } from '@/pages/competence/CompetenceMatrixPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { z } from 'zod';

const matrixSearchSchema = z.object({
	role: z
		.enum([
			'OWNER',
			'ADMIN',
			'EDITOR',
			'MEETING_ADMIN',
			'MEETING_ADMIN_WITHOUT_RECORDING',
			'MEMBER',
			'SUPER_ADMIN',
			'SUPER_ADMIN_WITHOUT_RECORDING',
		])
		.optional(),
	category: z.string().optional(),
	requiredOnly: z.coerce.boolean().optional(),
	issuesOnly: z.coerce.boolean().optional(),
	search: z.string().optional(),
	sortBy: z.enum(['name', 'role', 'issueCount']).optional(),
	tab: z.enum(['overview', 'approvals', 'types']).optional(),
	// Deep link from the archive / hard-delete dialogs lands the user here
	// with the matrix scoped to the records of a single competence type so
	// they can decide what to do before confirming a destructive action.
	competenceTypeId: z.string().optional(),
	// Types-tab table state (TablePage URL params survive this route's validation).
	scope: z.enum(['CHAIN', 'COMPANY']).optional(),
	page: z.coerce.number().optional(),
	limit: z.coerce.number().optional(),
});

export const Route = createFileRoute('/_authenticated/_app/competence/matrix')({
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['competence.read'], redirectTo: '/dashboard' }),
	component: CompetenceMatrixPage,
	validateSearch: matrixSearchSchema,
});
